import Api from '../PlanAnnotationsApi';
import * as types from './PlanAnnotationActionTypes';

function getPlacementsSuccess(result: any) {
    return { type: types.GET_PLACEMENTS_SUCCESS, result: result };
}

export function getPlacements(planOrderId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        Api.getPlacements(planOrderId).then((result: any) => {
            dispatch(getPlacementsSuccess(result));
        });
}
